import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactNode, useState } from 'react'
import { ToastProvider } from '@shared/toast/ToastProvider'
import { ThemeProvider } from '@shared/theme/ThemeProvider'
import { GlobalLoader } from '@shared/components/GlobalLoader'

export function AppProviders({ children }: { children: ReactNode }) {
  const [client] = useState(() => new QueryClient())
  return (
    <QueryClientProvider client={client}>
      <ThemeProvider>
        <ToastProvider>
          <GlobalLoader />
          {children}
        </ToastProvider>
      </ThemeProvider>
    </QueryClientProvider>
  )
}
